/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
// import { debounce } from 'lodash';
import { FieldArray } from 'formik';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// api
import ApiKey from '../../../api/ApiKey';
import BaseApi from '../../../api/BaseApi';
import { getCities } from '../../../employersSide/api/getCities';
// components
import Select from '../../components/Select';
import TextEditor from '../../components/TextEditor';
import SelectReact from '../../components/SelectReact';
import InputCheckbox from '../../components/InputCheckbox';
import TextEditorDraft from '../../components/TextEditorDraft';
import AsyncSelectReact from '../../components/AsyncSelectReact';
import SelectWithIdInOptions from '../../components/SelectWithIdInOptions';
import AutocompleteCreatableAsync from '../../components/AutocompleteCreatableAsync';
// helpers
import { debounceAsync } from '../../../helpers';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';

const getCountryName = (id, array) => {
  const country = array.find(item => item.id == id);

  return country ? { label: country.name, value: country.id } : undefined;
};

const WorkExperienceBlock = ({ errors, values, touched, directories, handleChange, setFieldValue, setFieldTouched }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const { experiences = [] } = values;
  const { months = [], yearList = [], countries = [], industries = [] } = directories;

  // const [prevValues, setPrevValues] = useState({ exp_city: [], position: [], organization: [] });
  // const [editorValues, setEditorValues] = useState(experiences.map(exp => exp.achievements || ''));

  const getCitiesOptions = async (inputValue, index) => {
    if (!experiences[index].exp_country || inputValue.length < 2) {
      return [];
    }

    try {
      const cities = await getCities(parseInt(experiences[index].exp_country), inputValue);

      if (cities.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = cities.data.response.map(city => ({
        value: city.id,
        label: `${city.name}${city.region && `, ${city.region}`}`,
      }));

      return options;
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [];
    }
  };

  const getSelectOptions = async (endpoint, inputValue) => {
    if (inputValue.length < 2) {
      return [];
    }

    try {
      const response = await axios.post(
        BaseApi + endpoint,
        { query: inputValue },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = response.data.response.map(position => ({
        value: position.id,
        label: position.name,
      }));

      return [
        ...options,
        { value: inputValue, label: inputValue },
      ];
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [{ value: inputValue, label: inputValue }];
    }
  };

  // const handleFocus = async (field, index) => {
  //   setPrevValues(prevState => {
  //     const newPrevState = { ...prevState };
  //     if (!newPrevState[field][index]) {
  //       newPrevState[field][index] = experiences[index][field] || '';
  //     }

  //     return newPrevState;
  //   });

  //   await setFieldValue(`experiences[${index}].${field}`, '');
  //   await setFieldError(`experiences[${index}].${field}`, '');
  // };

  // const handleBlur = async (field, index) => {
  //   if (!experiences[index][field]) {
  //     await setFieldValue(`experiences[${index}].${field}`, prevValues[field][index]);
  //   }
  // };

  const handleAddExperience = push => {
    push({
      exp_city: '',
      industry: [],
      position: '',
      exp_country: 5,
      to_year_exp: '',
      achievements: '',
      organization: '',
      still_working: 0,
      to_month_exp: '',
      from_year_exp: '',
      from_month_exp: '',
    });
  };

  const handleSelectChange = (name, selectedOptions, limit = null, index = null) => {
    if (limit && selectedOptions.length > limit) {
      return;
    }

    if (selectedOptions) {
      if (name === `experiences[${index}].exp_country`) {
        setFieldValue(name, selectedOptions.value);
      } else {
        setFieldValue(name, selectedOptions);
      }
    } else {
      setFieldValue(name, '');
    }
  };

  // const handleEditorChange = useCallback((value, index) => {
  //   const updatedEditorValues = [...editorValues];
  //   updatedEditorValues[index] = value;
  //   setEditorValues(updatedEditorValues);

  //   debouncedHandleEditorChange(value, index);
  // }, []); // eslint-disable-line

  const handleRemoveExperience = (index, remove) => {
    remove(index);

    // setPrevValues(prevValues => ({
    //   exp_city: prevValues.exp_city.filter((_, i) => i !== index),
    //   position: prevValues.position.filter((_, i) => i !== index),
    //   organization: prevValues.organization.filter((_, i) => i !== index),
    // }));
  };

  const debouncedGetCitiesOptions = debounceAsync(getCitiesOptions, 500);
  const debouncedGetSelectOptions = debounceAsync(getSelectOptions, 500);

  // const debouncedHandleEditorChange = debounce((value, index) => {
  //   setFieldValue(`experiences[${index}].achievements`, value);
  //   setFieldTouched(`experiences[${index}].achievements`, true);
  // }, 1000);

  useEffect(() => {
    if (width >= 768) {
      window.scrollTo({ top: 350, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 650, behavior: 'smooth' });
    }
  }, [width]);

  return (
    <>
      <div className='mt-4 mb-5'>
        <FieldArray
          name='experiences'
          render={({ push, remove }) => (
            experiences.map((i, index) => (
              <div key={index}>
                <AutocompleteCreatableAsync
                  required
                  value={i.position}
                  name={`experiences[${index}].position`}
                  label={t('jobseekerEditProfile.position')}
                  className={`${index === 0 ? 'mt-4' : 'mt-5'}`}
                  error={errors?.experiences?.[index]?.position}
                  touched={touched?.experiences?.[index]?.position}
                  placeholder={t('jobseekerEditProfile.enterPosition')}
                  loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
                  loadOptions={inputValue => debouncedGetSelectOptions('/candidates/getPositions', inputValue)}
                  handleChange={selectedOption => handleSelectChange(`experiences[${index}].position`, selectedOption)}
                  noOptionsMessage={
                    ({ inputValue }) => inputValue.length >= 2
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.enterPosition')
                  }
                  handleBlur={() => {
                    setTimeout(() => {
                      setFieldTouched(`experiences[${index}].position`, true);
                    }, 200);
                  }}
                />
                <AsyncSelectReact
                  required
                  isClearable
                  value={i.organization}
                  name={`experiences[${index}].organization`}
                  label={t('jobseekerEditProfile.organization')}
                  error={errors?.experiences?.[index]?.organization}
                  touched={touched?.experiences?.[index]?.organization}
                  placeholder={t('jobseekerEditProfile.enterOrganization')}
                  loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
                  loadOptions={inputValue => debouncedGetSelectOptions('/candidates/getCompanies', inputValue)}
                  handleChange={selectedOption => handleSelectChange(`experiences[${index}].organization`, selectedOption)}
                  noOptionsMessage={
                    ({ inputValue }) => inputValue.length >= 2
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.enterOrganization')
                  }
                  // handleFocus={() => {
                  //   if (width >= 1200) {
                  //     handleFocus('organization', index);
                  //   }
                  // }}
                  handleBlur={() => {
                    // if (width >= 1200) {
                    //   handleBlur('organization', index);
                    // }

                    setTimeout(() => {
                      setFieldTouched(`experiences[${index}].organization`, true);
                    }, 200);
                  }}
                />
                <SelectReact
                  isMulti
                  required
                  isSearchable
                  value={i.industry}
                  name={`experiences[${index}].industry`}
                  label={t('jobseekerEditProfile.industry')}
                  error={errors?.experiences?.[index]?.industry}
                  touched={touched?.experiences?.[index]?.industry}
                  placeholder={t('jobseekerEditProfile.selectIndustry')}
                  options={industries.map(i => ({ value: i.id, label: i.name }))}
                  noOptionsMessage={() => t('jobseekerEditProfile.noOptionsFound')}
                  handleBlur={() => setFieldTouched(`experiences[${index}].industry`, true)}
                  handleChange={selectedOption => handleSelectChange(`experiences[${index}].industry`, selectedOption, 5)}
                />
                <SelectReact
                  required
                  isClearable
                  isSearchable
                  label={t('jobseekerEditProfile.country')}
                  name={`experiences[${index}].exp_country`}
                  value={getCountryName(i.exp_country, countries)}
                  error={errors?.experiences?.[index]?.exp_country}
                  touched={touched?.experiences?.[index]?.exp_country}
                  placeholder={t('jobseekerEditProfile.selectCountry')}
                  options={countries.map(i => ({ value: i.id, label: i.name }))}
                  noOptionsMessage={() => t('jobseekerEditProfile.noOptionsFound')}
                  handleBlur={() => setFieldTouched(`experiences[${index}].exp_country`, true)}
                  handleChange={selectedOptions => {
                    handleSelectChange(`experiences[${index}].exp_country`, selectedOptions, null, index);
                    setFieldValue(`experiences[${index}].exp_city`, '');
                  }}
                />
                {
                  i.exp_country && (
                    <AsyncSelectReact
                      isClearable
                      value={i.exp_city}
                      label={t('jobseekerEditProfile.city')}
                      name={`experiences[${index}].exp_city`}
                      error={errors?.experiences?.[index]?.exp_city}
                      touched={touched?.experiences?.[index]?.exp_city}
                      placeholder={t('jobseekerEditProfile.enterCityName')}
                      loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
                      loadOptions={inputValue => debouncedGetCitiesOptions(inputValue, index)}
                      handleChange={selectedOption => handleSelectChange(`experiences[${index}].exp_city`, selectedOption)}
                      noOptionsMessage={
                        ({ inputValue }) => inputValue.length >= 2
                          ? t('jobseekerEditProfile.noOptionsFound')
                          : t('jobseekerEditProfile.enterCityName')
                      }
                      // handleFocus={() => {
                      //   if (width >= 1200) {
                      //     handleFocus('exp_city', index);
                      //   }
                      // }}
                      handleBlur={() => {
                        // if (width >= 1200) {
                        //   handleBlur('exp_city', index);
                        // }

                        setTimeout(() => {
                          setFieldTouched(`experiences[${index}].exp_city`, true);
                        }, 200);
                      }}
                    />
                  )
                }
                <div className='row'>
                  <div className='col-lg-6'>
                    <p className='mb-4'>
                      {t('jobseekerEditProfile.startOfWork')}
                    </p>
                    <div className='row'>
                      <SelectWithIdInOptions
                        required
                        options={months}
                        className='col-lg-6'
                        value={i.from_month_exp}
                        label={t('jobseekerEditProfile.month')}
                        handleChange={e => handleChange(e, index)}
                        name={`experiences[${index}].from_month_exp`}
                        error={errors?.experiences?.[index]?.from_month_exp}
                        defaultOption={t('jobseekerEditProfile.selectMonth')}
                        touched={touched?.experiences?.[index]?.from_month_exp}
                        errorMessage={errors?.experiences?.[index]?.from_month_exp}
                        handleBlur={() => setFieldTouched(`experiences[${index}].from_month_exp`, true)}
                      />
                      <Select
                        required
                        options={yearList}
                        className='col-lg-6'
                        value={i.from_year_exp}
                        label={t('jobseekerEditProfile.year')}
                        handleChange={e => handleChange(e, index)}
                        name={`experiences[${index}].from_year_exp`}
                        error={errors?.experiences?.[index]?.from_year_exp}
                        defaultOption={t('jobseekerEditProfile.selectYear')}
                        touched={touched?.experiences?.[index]?.from_year_exp}
                        errorMessage={errors?.experiences?.[index]?.from_year_exp}
                        handleBlur={() => setFieldTouched(`experiences[${index}].from_year_exp`, true)}
                      />
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <p className='mb-4'>
                      {t('jobseekerEditProfile.endOfWork')}
                    </p>
                    <div className='row'>
                      <SelectWithIdInOptions
                        options={months}
                        className='col-lg-6'
                        value={i.to_month_exp}
                        required={!i.still_working}
                        label={t('jobseekerEditProfile.month')}
                        name={`experiences[${index}].to_month_exp`}
                        error={errors?.experiences?.[index]?.to_month_exp}
                        defaultOption={t('jobseekerEditProfile.selectMonth')}
                        touched={touched?.experiences?.[index]?.to_month_exp}
                        errorMessage={errors?.experiences?.[index]?.to_month_exp}
                        handleBlur={() => setFieldTouched(`experiences[${index}].to_month_exp`, true)}
                        handleChange={e => {
                          handleChange(e, index);
                          setFieldValue(`experiences[${index}].still_working`, false);
                        }}
                      />
                      <Select
                        options={yearList}
                        className='col-lg-6'
                        value={i.to_year_exp}
                        required={!i.still_working}
                        label={t('jobseekerEditProfile.year')}
                        name={`experiences[${index}].to_year_exp`}
                        error={errors?.experiences?.[index]?.to_year_exp}
                        defaultOption={t('jobseekerEditProfile.selectYear')}
                        touched={touched?.experiences?.[index]?.to_year_exp}
                        errorMessage={errors?.experiences?.[index]?.to_year_exp}
                        handleBlur={() => setFieldTouched(`experiences[${index}].to_year_exp`, true)}
                        handleChange={e => {
                          handleChange(e, index);
                          setFieldValue(`experiences[${index}].still_working`, false);
                        }}
                      />
                    </div>
                  </div>
                  <InputCheckbox
                    checked={i.still_working}
                    name={`experiences[${index}].still_working`}
                    label={t('jobseekerEditProfile.stillWorking')}
                    handleChange={e => {
                      const isChecked = e.target.checked;

                      setFieldValue(`experiences[${index}].still_working`, isChecked);

                      if (isChecked) {
                        setFieldValue(`experiences[${index}].to_year_exp`, '');
                        setFieldValue(`experiences[${index}].to_month_exp`, '');
                      }
                    }}
                  />
                </div>
                {
                  width >= 768
                    ? (
                      <TextEditor
                        required
                        value={i.achievements}
                        name={`experiences[${index}].achievements`}
                        minHeight={width >= 768 ? '240px' : '280px'}
                        label={t('jobseekerEditProfile.achievements')}
                        error={errors?.experiences?.[index]?.achievements}
                        touched={touched?.experiences?.[index]?.achievements}
                        placeholder={t('jobseekerEditProfile.achievementsPlaceholder')}
                        // handleBlur={achievements => handleEditorChange(achievements, index)}
                        handleBlur={achievements => setFieldValue(`experiences[${index}].achievements`, achievements)}
                      />
                    ) : (
                      <TextEditorDraft
                        required
                        value={i.achievements}
                        name={`experiences[${index}].achievements`}
                        minHeight={width >= 768 ? '240px' : '280px'}
                        label={t('jobseekerEditProfile.achievements')}
                        error={errors?.experiences?.[index]?.achievements}
                        touched={touched?.experiences?.[index]?.achievements}
                        placeholder={t('jobseekerEditProfile.achievementsPlaceholder')}
                        handleChange={achievements => setFieldValue(`experiences[${index}].achievements`, achievements)}
                      />
                    )
                }
                <div className={`${experiences.length > 1 && index < experiences.length - 1 && 'mb-5'} row`}>
                  <div className='removeButtonJobseeker'>
                    <button
                      type='button'
                      className='btn btn-primary button2'
                      disabled={experiences.length === 1}
                      onClick={() => handleRemoveExperience(index, remove)}
                    >
                      {t('jobseekerEditProfile.removeButton')}
                    </button>
                    {
                      index === experiences.length - 1 && (
                        <button
                          type='button'
                          className='btn btn-primary button1'
                          onClick={() => handleAddExperience(push)}
                        >
                          {t('jobseekerEditProfile.addMoreButton')}
                        </button>
                      )
                    }
                  </div>
                </div>
                {experiences.length > 1 && index < experiences.length - 1 && <hr />}
              </div>
            ))
          )}
        />
      </div>
    </>
  );
};

export default WorkExperienceBlock;
